import * as z from "zod";

import { StoreApiTokenSummarySchema } from "../shared/api-token";
import { storeIdSchema } from "../shared/store";

export const listStoreApiTokens = {
  name: "listStoreApiTokens" as const,
  input: z.object({ storeId: storeIdSchema }),
  output: z.object({ tokens: z.array(StoreApiTokenSummarySchema) }),
};
